import React from 'react';
import { Box } from '@mui/material';

import { ALE } from './tokens';

// Syntax-highlight colors (ported from the design's .jk/.js/.jn/.jb/.jnull).
const C = {
    key: ALE.pDark,
    str: '#0a7d4d',
    num: '#c2410c',
    bool: '#7c3aed',
    null: ALE.g500,
};

const esc = (s: string) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

/** Pretty-print a JSON value to highlighted HTML (2-space indent). */
function jsonHtml(value: unknown, indent = 0): string {
    const pad0 = '  '.repeat(indent);
    const pad1 = '  '.repeat(indent + 1);
    if (value === null || value === undefined) return `<span style="color:${C.null}">null</span>`;
    const t = typeof value;
    if (t === 'boolean') return `<span style="color:${C.bool}">${value}</span>`;
    if (t === 'number') return `<span style="color:${C.num}">${value}</span>`;
    if (t === 'string') return `<span style="color:${C.str}">"${esc(value as string)}"</span>`;
    if (Array.isArray(value)) {
        if (!value.length) return '[]';
        const items = value.map((v) => pad1 + jsonHtml(v, indent + 1));
        return `[\n${items.join(',\n')}\n${pad0}]`;
    }
    const keys = Object.keys(value as object);
    if (!keys.length) return '{}';
    const rows = keys.map(
        (k) => `${pad1}<span style="color:${C.key}">"${esc(k)}"</span>: ${jsonHtml((value as any)[k], indent + 1)}`,
    );
    return `{\n${rows.join(',\n')}\n${pad0}}`;
}

export const JsonView: React.FC<{ value: unknown }> = ({ value }) => (
    <Box
        sx={{
            bgcolor: ALE.g100,
            border: `1px solid ${ALE.border}`,
            borderRadius: '8px',
            padding: '14px 16px',
            fontFamily: ALE.mono,
            fontSize: '12.5px',
            lineHeight: 1.6,
            color: ALE.g800,
            overflowX: 'auto',
            whiteSpace: 'pre',
            tabSize: 2,
        }}
        dangerouslySetInnerHTML={{ __html: jsonHtml(value, 0) }}
    />
);
